/**
 * Named route middleware: only the Capacitor native shell (`public.NUXT_CAPACITOR_APP`) may
 * enter the route. In the web build the user is sent to the storefront home via
 * `navigateTo(storefrontUrl, { external: true })` when a storefront URL is configured; if none
 * is set, the navigation is left unchanged.
 *
 * Usage on a page:
 * `definePageMeta({ middleware: 'is-capacitor' })`
 */
export default defineNuxtRouteMiddleware(() => {
    const config = useRuntimeConfig() as { public?: { NUXT_CAPACITOR_APP?: boolean } }
    if (!config.public?.NUXT_CAPACITOR_APP) {
        if (import.meta.dev) {
            // eslint-disable-next-line no-console
            console.log('not capacitor app, redirecting to home...')
        }

        const { getRedirectConfig } = useRedirectHelpers()
        const { storefrontUrl } = getRedirectConfig()

        if (!storefrontUrl) {
            return
        }

        return navigateTo(storefrontUrl, { external: true })
    }
})
